import axios from "@/plugins/axios";

let url = "/api/console/users/cashes";

export default {
    gets(data){
        return axios.get(url, data).then(result => result.data);
    },
    post(data){
        return axios.post(url, data).then(result => result.data);
    },
}
